<h2 mat-dialog-title>{{ 'New component' | translate }}</h2>
<mat-dialog-content [formGroup]="form">

  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Title' | translate }}</div>
    <input matInput type="text" formControlName="title">
    <mat-error *ngIf="form.get('title')?.touched && form.get('title')?.hasError('required')">{{ 'Title is required' | translate }}</mat-error>
  </div>

  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Type' | translate }}</div>
    <select formControlName="type" inactif matNativeControl>
      <option *ngFor="let pageType of pageTypes" [value]="pageType.value">{{ pageType.key }}</option>
    </select>
  </div>

  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Id' | translate }}</div>
    <input matInput type="text" formControlName="pageId">
    <mat-error *ngIf="form.get('pageId')?.invalid && form.get('pageId')?.dirty">{{ 'Invalid GUID format' | translate }} (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)</mat-error>
  </div>

  <div class="cdc-form-field actif">
    <div class="cdc-label">
      {{ 'Parent' | translate }}
    </div>
    <select formControlName="parentPage" matNativeControl>
      <option [ngValue]="null">{{'Without parent' | translate}}</option>
      <option *ngFor="let parent of pagesParentAvailable" [ngValue]="parent">{{ parent.title }}</option>
    </select>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="form.invalid">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>

